<template>
  <div class="mt-4 mx-3 row white-box px-3 py-4">
    <div class="white-box-top"></div>
    <div class="col-md-4 col-lg-2">
      <nav class="left-nav">
        <button
          class="btn w-100 text-start"
          v-on:click="active = 'assets'"
          :class="active === 'assets' ? 'btn-primary' : 'btn-simple'"
        >
          Assets
        </button>
      </nav>
    </div>
    <div class="col-md-8 col-lg-10">
      <h2>Assets</h2>
      <CustomRows v-model:type="active" />
    </div>
  </div>
</template>

<script>
import CustomRows from "@/components/settings/products/CustomRows";

export default {
  name: "AssetsSettings",
  components: { CustomRows },
  data() {
    return {
      active: "assets",
    };
  },
};
</script>
